import { useNavigate } from 'react-router-dom';

export default function UpgradePaywall({ attemptsUsed = 1, attemptsLimit = 1 }) {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-purple-800 flex items-center justify-center p-6">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl p-8 md:p-12">
        {/* Lock Icon */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-24 h-24 bg-red-100 rounded-full mb-4">
            <span className="text-6xl">🔒</span>
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">
            Free Trial Used
          </h1>
          <p className="text-xl text-gray-600">
            You've completed your {attemptsUsed} free {attemptsUsed === 1 ? 'quiz' : 'quizzes'}
          </p>
        </div>

        {/* Upgrade Message */}
        <div className="bg-gradient-to-r from-red-50 to-yellow-50 border-l-4 border-red-500 p-6 rounded-lg mb-8">
          <p className="text-lg font-semibold text-gray-800 mb-2">
            🎯 Don't risk failing your citizenship test!
          </p>
          <p className="text-gray-700">
            One practice quiz isn't enough to prepare. Upgrade now to get unlimited practice, exam simulation, and detailed analytics.
          </p>
        </div>

        {/* What You Get */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">
            Upgrade to Premium - Only $14.99 CAD
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            <div className="bg-green-50 rounded-lg p-4 border border-green-200">
              <div className="flex items-start">
                <span className="text-2xl mr-3">✅</span>
                <div>
                  <p className="font-semibold text-gray-900">Unlimited Quizzes</p>
                  <p className="text-sm text-gray-600">Practice as much as you need</p>
                </div>
              </div>
            </div>

            <div className="bg-green-50 rounded-lg p-4 border border-green-200">
              <div className="flex items-start">
                <span className="text-2xl mr-3">⏱️</span>
                <div>
                  <p className="font-semibold text-gray-900">Exam Simulation</p>
                  <p className="text-sm text-gray-600">30-min timer, real test conditions</p>
                </div>
              </div>
            </div>

            <div className="bg-green-50 rounded-lg p-4 border border-green-200">
              <div className="flex items-start">
                <span className="text-2xl mr-3">📊</span>
                <div>
                  <p className="font-semibold text-gray-900">Detailed Analytics</p>
                  <p className="text-sm text-gray-600">Track performance by topic</p>
                </div>
              </div>
            </div>

            <div className="bg-green-50 rounded-lg p-4 border border-green-200">
              <div className="flex items-start">
                <span className="text-2xl mr-3">🔄</span>
                <div>
                  <p className="font-semibold text-gray-900">Review Mistakes</p>
                  <p className="text-sm text-gray-600">Learn from wrong answers</p>
                </div>
              </div>
            </div>

            <div className="bg-green-50 rounded-lg p-4 border border-green-200">
              <div className="flex items-start">
                <span className="text-2xl mr-3">⚡</span>
                <div>
                  <p className="font-semibold text-gray-900">Timed Challenges</p>
                  <p className="text-sm text-gray-600">Practice under pressure</p>
                </div>
              </div>
            </div>

            <div className="bg-green-50 rounded-lg p-4 border border-green-200">
              <div className="flex items-start">
                <span className="text-2xl mr-3">🏆</span>
                <div>
                  <p className="font-semibold text-gray-900">Achievements</p>
                  <p className="text-sm text-gray-600">Stay motivated with badges</p>
                </div>
              </div>
            </div>
          </div>

          {/* Value Proposition */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-center text-gray-700">
              <span className="font-bold text-blue-900">$14.99 CAD</span> is cheaper than:
            </p>
            <ul className="text-sm text-gray-600 mt-2 space-y-1">
              <li>📚 Study books ($30-50)</li>
              <li>⏰ Failing and waiting 3 months to retake (priceless)</li>
              <li>🎓 In-person classes ($100-300)</li>
            </ul>
            <p className="text-center font-bold text-blue-900 mt-3">
              One-time payment • Lifetime access • No subscription
            </p>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="space-y-3">
          <button
            onClick={() => navigate('/payment')}
            className="w-full py-4 bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white font-bold text-lg rounded-xl shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] transition-all"
          >
            🚀 Upgrade to Premium - $14.99 CAD
          </button>

          <button
            onClick={() => navigate('/dashboard')}
            className="w-full py-3 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold rounded-xl transition-all"
          >
            Back to Dashboard
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="mt-6 text-center text-sm text-gray-500">
          <p>✅ Secure payment via Stripe</p>
          <p>✅ Based on official "Discover Canada" guide</p>
          <p>✅ 597 real citizenship test questions</p>
        </div>
      </div>
    </div>
  );
}
